import { PMDonutChartCard } from "@pimo/pimo-components/src/lib/pm-components";

import {
  getDropdownCount,
  getSemaphoreStatusOptions,
} from "../../../utils/dropdown-options";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addSemaphoreStatusOfItemsDonutChartCard(
  ctx: DashboardCardContext
) {
  const { view, projectName, projectNamePlural, getCardCopy } = ctx;

  const semaphoreStatusOfItemsDonutChartComponent = view.addComponent({
    component: PMDonutChartCard,
    layoutProps: {
      componentId: "statusOfItemsDonutChartComponent",
      title: "",
      description: "",
      labels: ["donutChart", "chart", "status"],
    },
  });
  semaphoreStatusOfItemsDonutChartComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "statusOfItemsDonutChartComponent",
      labels: ["donutChart", "chart", "semaphoreStatus"],
      title: getCardCopy(language, "statusOfItems").title,
      description: getCardCopy(language, "statusOfItems").description,
    };
  });

  semaphoreStatusOfItemsDonutChartComponent.mapState(
    ({ dashboard, settings, language }) => {
      const statusCounts =
        dashboard?._calculated?.itemSemaphoreStatusCounts ?? {};
      const data = getSemaphoreStatusOptions(settings?.configuration).map(
        (entry) => {
          return {
            label: entry?.name ?? "",
            value: (entry && getDropdownCount(statusCounts, entry)) ?? 0,
            color: entry?.color ?? "",
          };
        }
      );

      return {
        title: getLocalizedCardCopy(language, "statusOfItems", {
          itemName: getItemName(settings?.configuration?.itemName, language),
          itemNamePlural: getPluralOfItemName(
            settings?.configuration?.itemName,
            language
          ),
          projectName,
          projectNamePlural,
        }).title,
        description: getCardCopy(language, "statusOfItems").description,
        icon: "DonutLarge",
        data,
      };
    }
  );

  semaphoreStatusOfItemsDonutChartComponent.mapVisibility(({ settings }) => {
    return (
      isFieldEnabled(settings, "status", "itemReporting") &&
      (settings?.configuration?.statusReportingLevel ?? "overall") ===
        "category"
    );
  });
}
